import Vue from 'vue';
import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
import ZoomOnHover from "vue-zoom-on-hover";
Vue.use(ZoomOnHover);
import vClickOutside from 'v-click-outside';
import filters from './services/filter'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use( infiniteScroll )

import Skeleton from "vue-loading-skeleton";
 Vue.use(Skeleton);
Vue.use(vClickOutside);

import VueGtm from 'vue-gtm';
import VueGtag from "vue-gtag";
import router from './router';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
var gtmUrl = location.host;

export const bus = new Vue();

import * as VueGoogleMaps from "vue2-google-maps";
import ResponsiveImage from "@kartmax-technology/kartmax-responsive-image-vue/responsive-image";  
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc",
    libraries: "places" // necessary for places input
  }
});

if (gtmUrl === 'localhost:8080' || gtmUrl === 'www.lhm.greenhonchos.com' || gtmUrl === 'www.wndw.in') {
  Vue.use(VueGtm, {
    // id: 'UA-204034571-1',
    id: 'GTM-5DNV57L',
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router
  });
  
};
const firebaseConfig = {
  apiKey: "AIzaSyBlos9Gip_1lQ_h5Cv7Pc2pibI0kYUouJ8",
  authDomain: "wndw-9707f.firebaseapp.com",
  projectId: "wndw-9707f",
  storageBucket: "wndw-9707f.appspot.com",
  messagingSenderId: "553792460520",
  appId: "1:553792460520:web:133c5aec7f365ff27bdb5d",
  measurementId: "G-NYSGJZYQMQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
Vue.use(VueGtag, {
  config: { id: "GTM-5DNV57L" }  //UA-204034571-1 old value in id 
}, router);

import pimweb from './App.vue';
import Ripple from 'vue-ripple-directive';
Ripple.color = 'rgba(0, 0, 0, 0.08)';
Ripple.zIndex = 999;
import vbclass from 'vue-body-class';
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';

Vue.component('loading-icon', VueLoaders.component);
Vue.component('ResponsiveImage',ResponsiveImage);

Vue.use(vbclass, router);
Vue.directive('ripple', Ripple);
Vue.config.productionTip = false;
var vm = new Vue({
  metaInfo() {
    return {
      title: this.meta_title,
      meta: [
        {
          name: 'google-site-verification',
          content: this.meta_google_content
        },
       
      ]
    }
  },
  computed : {
    summary () {
      let totalMRP = 0, discountMRP= 0
      this.cart_product.forEach(element => {
          totalMRP = totalMRP + element.price * element.qty
          discountMRP = discountMRP + element.selling_price * element.qty

          
      });
      discountMRP = totalMRP - discountMRP - this.$root.discount_amount

      return {totalMRP: totalMRP, discountMRP: discountMRP}

    }

   },
  data: function () {
    return {
      admin_url:'',
			keepCartMessage:
				"Sorry, this product is not available in this much quantity.",
			searchCount: 0,
			window: {
				width: 0,
				height: 0,
			},
			midBanner: [],
			bottomBanner: [],
			isStorePopUpMobile: false,
			customerName: "",
			mapMarker: {},
      isMobile: false,
			title: "",
			isStore: true,
			wishListProducts: 0,
			pcart: null,
			numberOfStores: 1,
			path: null,
			store: false,
			storesData: [],
			back_after_login: false,
			pages: [],
			login_popup: false,
			login_detail: false,
			meta_google_content: "",
			error_message: "",
			success_message: "",
			page_loader: false,
			cart_product: [],
			search_input: "",
			gtm_product: [],
			menu: [],
			cart_subtotal: "",
			cart_total: "",
			shipping_charge: "",
			cart_netAmount: "",
			customer_detail: "",
			minicart: true,
			menuActive: true,
			address: [],
			select_address_no: "",
			address_id: "",
			product_type: "",
			cart_id: "",
			customer_id: "",
			customer_session: "",
			cart_session: "",
			g_customer_id: "",
			login_status: "",
			discount_code: null,
			thankyou_status: "",
			thankyou_cart: "",
			storeCredit: "",
			nearestCategories: {},
			locationAddresses: [],
			discount_amount: "",
      
    
			location: {
				lat: null,
				long: null,
			},
			cityName: "",
			locationPlaceId: "",
			isLocation: false,
			customerDetails: {
				name: "",
				number: "",
			},
			store: 2,
			image_url_c: "https://images.wndw.in/live/",
			api_url: "https://lhmpim.greenhonchos.com",
		 
			breadcrumb: "",
			breadcrumb_second: {
				name: "",
				url: "",
			},
			cart_api: "https://lhmcart-pim.greenhonchos.com/api/v1",
		};
  },
  methods: {
    percentOff(price = 0, sellingPrice = 0, showOff = true) {
      let percentOff 
      percentOff = (100 -(sellingPrice * 100) / price).toFixed(0) 
      if(percentOff > 0) {
        return `( ${percentOff}% ${showOff ? 'Off': ''})`
      }else {
        return 
      }


    },
    
  },
  created: function () {
    if (window.innerWidth < 767) {
      this.isMobile = true; 
    }
    this.path = this.$route.fullPath;
    this.thankyou_status = VueCookies.get(window.location.hostname.substring(10, 4) + '_thank');
    this.pcart = VueCookies.get(window.location.hostname.substring(10, 4) + '_cart');
    this.thankyou_cart = VueCookies.get(window.location.hostname.substring(10, 4) + '_cart');
    this.customer_id = VueCookies.get(window.location.hostname.substring(10, 4) + '_customer');
    this.customer_session = VueCookies.get(window.location.hostname.substring(10, 4) + '_cs');
    this.cart_session = VueCookies.get(window.location.hostname.substring(10, 4) + '_carts');
    this.location.lat = VueCookies.get(window.location.hostname.substring(10, 4) + '_location_lat');
    this.location.long = VueCookies.get(window.location.hostname.substring(10, 4) + '_location_long');
    if ((this.thankyou_status === false || this.thankyou_status === null) && this.$route.name === 'Thankyou') {
      this.$router.push('/')
    }
    var currentUrl = location.host;
    if (currentUrl === 'wndw.in' || currentUrl === 'www.wndw.in') 
    {
      this.api_url = 'https://pim.wndw.in';
      this.cart_api = 'https://cart.wndw.in/api/v1';
      this.admin_api='https://admin.wndw.in/api'

      this.image_url_c = 'https://images.wndw.in/live/'
      console.log = function() {}

    }
    if ( currentUrl === 'localhost:8080' || currentUrl === 'localhost:8081' || currentUrl === 'localhost:8087' || currentUrl === 'lhm.greenhonchos.com' )
    {
      this.admin_api='https://lhmadmin.greenhonchos.com/api'
      this.api_url = 'https://lhmpim.greenhonchos.com',
      this.cart_api = 'https://lhmcart-pim.greenhonchos.com/api/v1';
      this.image_url_c = 'https://images.wndw.in/live/'

    }
  },
  watch: {
    cart_product: {
      handler: function () {
        if(this.cart_product){
        this.gtm_product = [];
        this.product_type = "";
        for (let i = 0; i < this.cart_product.length; i++) {

          if (this.cart_product[i].product_type == 'gift') {
     
            this.product_type = "gift";
          }
          let name = this.cart_product[i].name;
          let id = this.cart_product[i].master_sku;
          let price = this.cart_product[i].selling_price;
          let variant = this.cart_product[i].size;
          let category = this.cart_product[i].category;
          let quantity = this.cart_product[i].qty;
          this.gtm_product.push({ name, id, price, variant, category, quantity });
        }
      }
      }
    },

    customer_id: {
      handler: function (after, before) {
        if (this.customer_id != null && this.customer_id != '') {
          this.login_status = 'Registered';
        }
        else {
          this.login_status = 'Guest';
        }
      }
    },
    $route(to, from) {
      this.breadcrumb = '';
      this.breadcrumb_second.name = '';
      this.breadcrumb_second.url = '';
      if ((this.thankyou_status === false || this.thankyou_status === null) && this.$route.name === 'Thankyou') {
        this.$router.push('/')
      }
      if (this.store === 1) {
        document.body.classList.add('w-store');
      }
      else {
        document.body.classList.add('a-store');
      }
      if (this.login_status === 'Registered') {
        // this.$gtm.trackEvent({
        //   event: 'Login_status',
        //   category: 'Login_status',
        //   action: 'Logged in',
        //   Mobile_no: this.$root.customer_detail.phone,
        //   Email: this.$root.customer_detail.email,
        // });

      }
      else {
      }
      // if (to.name === 'st_search') {
      //   document.getElementById("st-container-hide").style.display = "none";
      //   document.getElementById("searchModalContainer").style.display = "block";
      // }
      // else {
      //   this.search_input = '';
      //   document.getElementById("search").value = "";
      //   document.getElementById("st-container-hide").style.display = "block";
      //   document.getElementById("searchModalContainer").style.display = "none";
      // }

    },
  },
  router,
  filters,
  render: h => h(pimweb),
}).$mount('#pim_main')
